<template>
  <div>
    <v-col sm="12" class="px-0 pt-0">
      <v-row
        v-if="
          !isLoggedInAsBO &&
            dataItems.length &&
            filterBy !== 'budgetOwner' &&
            !submitableDiv
        "
      >
        <div>
          <img
            src="@/assets/images/icon/location.png"
            width="18px"
            height="auto"
            class="mt-2 ml-3"
          />
        </div>
        <span
          class="pl-2 pt-1 font-weight-medium subtitle-1 darkblue--text fs-14 font-weight-700"
          >Progress Tracking IO</span
        >
      </v-row>
      <!-- progress tracking -->
      <tracking-progress
        v-if="dataItems.length && page !== 'consolidated' && !submitableDiv"
        :item="stepItem"
        class="py-1"
      />
      <v-row v-if="!isLoggedInAsBO && page !== 'consolidated'">
        <div v-if="filterBy === 'budgetOwner' && submitableDiv" />
        <div v-else>
          <img
            src="@/assets/images/icon/file-text.png"
            width="18px"
            height="18px"
            class="ml-3 mt-1"
          />
        </div>
        <div v-if="filterBy === 'budgetOwner' && submitableDiv" />
        <span
          v-else
          class="pl-2 font-weight-medium subtitle-1 darkblue--text fs-14 font-weight-700"
        >
          Spending by Taxonomy
        </span>
      </v-row>
      <v-row
        v-else-if="isLoggedInAsBO && page !== 'consolidated' && !submitableDiv"
      >
        <div>
          <img
            src="@/assets/images/icon/file-text.png"
            width="20px"
            height="20px"
            class="ml-3 mt-1"
          />
        </div>
        <span
          class="pl-2 font-weight-medium subtitle-1 darkblue--text fs-14 font-weight-700"
        >
          Spending Information
        </span>
      </v-row>
      <table width="90%" class="darkblue--text my-2" v-if="dataItems.length">
        <tr>
          <td class="font-weight-bold">
            House
          </td>
          <td id="nameHouse">
            {{ info.house || '-' }}
          </td>
          <td class="font-weight-bold">
            Date Created
          </td>
          <td id="dateCreated">
            {{ info.date_created || '-' }}
          </td>
          <td class="font-weight-bold">
            Last Change
          </td>
          <td id="lastApproval">
            {{ info.last_changed || '-' }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            Brand
          </td>
          <td id="nameBudget">
            {{ info.brand.join() || '-' }}
          </td>
          <td class="font-weight-bold">
            Budget Code
          </td>
          <td id="budgetId">
            {{ info.budget_id || '-' }}
          </td>
        </tr>
      </table>

      <hr class="hr-line" v-if="dataItems.length" />
      <v-row>
        <v-spacer></v-spacer>
        <v-menu :close-on-content-click="false" v-if="page !== 'consolidated'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="btn-column"
              class="primary--text pb-0 mr-3"
              depressed
              color="lightblue"
              v-bind="attrs"
              v-on="on"
            >
              Select Column
            </v-btn>
          </template>
          <v-list-item-group v-model="columnActive" multiple class="menuColumn">
            <div
              class="px-4 py-2"
              @click="selectAllColumn()"
              style="cursor:pointer;"
            >
              <v-row>
                <v-flex xs2 class="ml-4" style="max-width: 37px !important;">
                  <v-icon v-if="selectAll" color="primary accent-4">
                    check_box
                  </v-icon>
                  <v-icon color="primary accent-4" v-else>
                    check_box_outline_blank
                  </v-icon>
                </v-flex>
                <v-flex xs8 class="pt-1">
                  <v-list-item-title class="text-left">
                    Select All
                  </v-list-item-title>
                </v-flex>
              </v-row>
            </div>
            <template v-for="(item, i) in spendingColumn">
              <v-divider v-if="!item" :key="'divider' + i"></v-divider>

              <v-list-item
                v-else
                :key="'item' + i"
                :value="item.title"
                class="text-left"
                style="max-height: 48px !important;"
                active-class="primary--text text--accent-4"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content style="max-width: 20px !important;">
                  </v-list-item-content>

                  <v-list-item-action style="width: 100%">
                    <v-flex xs12>
                      <v-row>
                        <v-flex xs2 style="padding-top: 3.5px;">
                          <v-icon color="primary accent-4" v-if="active">
                            check_box
                          </v-icon>
                          <v-icon v-else color="primary accent-4">
                            check_box_outline_blank
                          </v-icon>
                        </v-flex>
                        <v-flex xs8 class="pt-1">
                          <v-list-item-title
                            class="text-left"
                            v-text="item.title"
                          >
                          </v-list-item-title>
                        </v-flex>
                      </v-row>
                    </v-flex>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-menu>
        <!-- Download io -->
        <v-menu v-if="page !== 'consolidated'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="btn-download-spending-byBo"
              class="white--text pb-0 mr-3"
              depressed
              color="thirdblue"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left dark>
                vertical_align_bottom
              </v-icon>
              Download
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="downloadSpending()">
              <v-list-item-title>
                Download Spending Report
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="downloadByIO(dataItem)"
              v-if="hasPermission('download_report', 'view')"
            >
              <v-list-item-title>
                Download IO SAP
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- Revise -->
        <v-btn
          v-if="
            isReviseable &&
              hasPermission('create_spending', 'create') &&
              isActiveRevise
          "
          id="btn-add-adhoc"
          depressed
          color="primary"
          class="white--text mr-3 f-14 pb-0"
          :to="{
            name: 'reviseUpload',
            params: { id: info.budget_id, flow: submitableDiv }
          }"
        >
          <v-icon left dark>add</v-icon>Mass Revision
        </v-btn>
      </v-row>
    </v-col>
    <!-- table io -->
    <v-col sm="12" class="pt-1 px-0">
      <v-simple-table fixed-header class="table-taxonomy nav-table">
        <template v-slot:default>
          <v-perfect-scroll
            class="drawer-menu--scroll"
            :settings="scrollSettings"
          >
            <thead>
              <tr>
                <th
                  width="41px"
                  style="padding: 0px 17px !important;"
                  v-if="singleSubmit"
                  :class="singleSubmit ? 'sticky-header1_' : ''"
                >
                  <v-layout align-center>
                    <label class="form-checkbox">
                      <input
                        class="checkbox-approval"
                        type="checkbox"
                        v-model="dataItem.selectAll"
                        @click="selectAllIO(dataItem)"
                      />
                      <span class="checkbox-custom"></span>
                    </label>
                  </v-layout>
                </th>
                <th
                  v-if="columnActive.includes('IO Number')"
                  class="f-14 white--text"
                  :class="singleSubmit ? 'sticky-header2_' : 'sticky-header1'"
                >
                  IO Number
                  <filter-column
                    field="io_number"
                    @sortAsc="getNestedSort"
                    @searchColumn="searchCln"
                    :listFilter="getFiltered('io_number')"
                    @filterItem="searchCln"
                    :isCode="true"
                  />
                </th>
                <th
                  v-if="columnActive.includes('Code')"
                  class="f-14 white--text"
                  :class="[
                    columnActive.includes('IO Number') && !singleSubmit
                      ? 'sticky-header2-spending'
                      : '',
                    columnActive.includes('IO Number') && singleSubmit
                      ? 'sticky-header3_'
                      : 'sticky-header2'
                  ]"
                >
                  Code
                  <filter-column
                    field="code"
                    @sortAsc="getNestedSort"
                    @searchColumn="searchCln"
                    :listFilter="getFiltered('code')"
                    @filterItem="searchCln"
                  />
                </th>
                <template v-for="(column, i) in spendingColumn">
                  <th
                    :key="'columnIndex -' + i"
                    v-if="columnActive.includes(column.title) && i > 1"
                    class="f-14 white--text"
                  >
                    {{ column.title }}
                    <filter-column
                      v-if="column.value !== 'action'"
                      :field="column.field"
                      @sortAsc="getNestedSort"
                      @searchColumn="searchCln"
                      :listFilter="getFiltered(column.field)"
                      @filterItem="searchCln"
                      :isCode="column.isCode ? column.isCode : false"
                      :columnType="
                        column.columnType ? column.columnType : false
                      "
                      :isDate="column.isDate ? column.isDate : false"
                    />
                  </th>
                </template>
                <th
                  v-if="
                    (isEditable || isReviseable) &&
                      hasPermission('create_spending', 'create')
                  "
                  class="f-14 white--text"
                >
                  Edit
                </th>
                <!-- <th
                  v-else-if="
                    isReviseable &&
                      hasPermission('create_spending', 'create') &&
                      isActiveRevise
                  "
                  class="f-14 white--text"
                >
                  <span>Modify</span>
                </th> -->
                <th
                  v-if="
                    isActionable && hasPermission('create_spending', 'create')
                  "
                  class="f-14 white--text"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody v-if="dataItems.length > 0">
              <tr
                v-for="(val, indexItem) in dataItems"
                :key="'dataitem' + indexItem"
                :class="
                  bgStatusActive(val.notes, val.isSearch, val.ioSupportDocs)
                "
              >
                <td
                  width="41px"
                  v-if="singleSubmit"
                  style="border-left: 1px solid rgb(230, 230, 230) !important; border-bottom: 1px solid rgb(230, 230, 230) !important"
                  :class="
                    singleSubmit
                      ? `sticky-body1_ ${bgStatusActive(
                          val.notes,
                          val.isSearch,
                          val.ioSupportDocs
                        )}`
                      : bgStatusActive(
                          val.notes,
                          val.isSearch,
                          val.ioSupportDocs
                        )
                  "
                >
                  <v-layout align-center>
                    <label class="form-checkbox">
                      <input
                        class="checkbox-approval"
                        type="checkbox"
                        :value="val.id"
                        v-model="dataItem.selected"
                        :disabled="
                          isDisableButton(val.status.toLowerCase())
                            ? 'disabled'
                            : false
                        "
                      />
                      <span class="checkbox-custom"></span>
                    </label>
                  </v-layout>
                </td>
                <td
                  v-if="columnActive.includes('IO Number')"
                  @click="goTo(val)"
                  style="cursor:pointer;text-decoration:underline"
                  class="primary--text row-highlight"
                  :class="[
                    bgReject(val.notes, val.isSearch, val.ioSupportDocs),
                    singleSubmit ? 'sticky-body2_' : 'sticky-body1'
                  ]"
                >
                  <router-link
                    :to="{
                      name: 'one-pager',
                      params: {
                        id: val.id,
                        submitable: submitableDiv ? submitableDiv : false
                      }
                    }"
                  >
                    {{ val.io_number ? val.io_number : '-' }}
                  </router-link>
                </td>
                <td
                  v-if="columnActive.includes('Code')"
                  @click="goTo(val)"
                  style="cursor:pointer;text-decoration:underline"
                  class="primary--text"
                  :class="[
                    bgReject(val.notes, val.isSearch, val.ioSupportDocs),
                    columnActive.includes('IO Number') && !singleSubmit
                      ? 'sticky-body2-spending row-highlight'
                      : '',
                    columnActive.includes('IO Number') && singleSubmit
                      ? 'sticky-body3_ row-highlight'
                      : 'sticky-body2'
                  ]"
                >
                  <router-link
                    :to="{
                      name: 'one-pager',
                      params: {
                        id: val.id,
                        submitable: submitableDiv ? submitableDiv : false
                      }
                    }"
                  >
                    {{ val ? val.code : '-' }}
                  </router-link>
                </td>
                <td v-if="columnActive.includes('Entity')">
                  <span v-if="val.brand">
                    {{ val.brand.entity ? val.brand.entity.name || '-' : '-' }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td v-if="columnActive.includes('Brand')">
                  {{ val.brand ? val.brand.name || '-' : '-' }}
                </td>
                <template v-for="(groupContent, iGroupContent) in val.group">
                  <td
                    v-if="columnActive.includes(groupContent.title.name)"
                    :key="'groupContent-' + iGroupContent"
                    class="text-capitalize"
                  >
                    <span v-if="groupContent.value">
                      {{ groupContent.value || '-' }}
                    </span>
                    <span v-else>-</span>
                  </td>
                </template>
                <td v-if="columnActive.includes('Product Hierarchy')">
                  {{ val.product ? val.product.name : '-' }}
                </td>
                <td v-if="columnActive.includes('Budget Owner')">
                  {{ val.budgetOwner ? val.budgetOwner.desc : '-' }}
                </td>
                <td
                  v-if="isLoggedInAsSales && columnActive.includes('Channel')"
                  :class="bgReject(val.notes, val.isSearch, val.ioSupportDocs)"
                >
                  <div class="pa-0" v-if="val.channels.length > 0">
                    <v-tooltip bottom v-if="val.channels.length > 3">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{
                            val.channels
                              .slice(0, 3)
                              .map(item => item.name)
                              .join(', ')
                          }}
                          ...
                        </span>
                      </template>
                      <span>
                        {{ val.channels.map(item => item.name).join(', ') }}
                      </span>
                    </v-tooltip>
                    <span v-else>
                      {{ val.channels.map(item => item.name).join(', ') }}
                    </span>
                  </div>
                  <span v-else>
                    {{ val.channels.length > 0 ? val.channels : '-' }}
                  </span>
                </td>
                <td
                  v-if="isLoggedInAsSales && columnActive.includes('Account')"
                  :class="bgReject(val.notes, val.isSearch, val.ioSupportDocs)"
                >
                  <div class="pa-0" v-if="val.ioAccount.length > 0">
                    <v-tooltip bottom v-if="val.ioAccount.length > 3">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{
                            val.ioAccount
                              .slice(0, 3)
                              .map(item => item.account.name)
                              .join(', ')
                          }}
                          ...
                        </span>
                      </template>
                      <span>
                        {{
                          val.ioAccount
                            .map(item => item.account.name)
                            .join(', ')
                        }}
                      </span>
                    </v-tooltip>
                    <span v-else>
                      {{
                        val.ioAccount.map(item => item.account.name).join(', ')
                      }}
                    </span>
                  </div>
                  <span v-else>
                    {{ val.ioAccount.length > 0 ? val.ioAccount : '-' }}
                  </span>
                </td>
                <td v-if="columnActive.includes('PIC')" class="text-capitalize">
                  {{ val ? val.pic : '-' }}
                </td>
                <td
                  v-if="columnActive.includes('Cost Center Description')"
                  class="text-capitalize"
                >
                  <span v-if="val.taxonomy">
                    {{
                      val.taxonomy.costCenter
                        ? val.taxonomy.costCenter.desc || '-'
                        : '-'
                    }}
                  </span>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td v-if="columnActive.includes('Cost Center')">
                  <span v-if="val.taxonomy">
                    {{
                      val.taxonomy.costCenter
                        ? val.taxonomy.costCenter.code || '-'
                        : '-'
                    }}
                  </span>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td v-if="columnActive.includes('Cost Element (GL Protein)')">
                  <span v-if="val.taxonomy">
                    {{
                      val.taxonomy.costElement
                        ? val.taxonomy.costElement.code || '-'
                        : '-'
                    }}
                  </span>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td
                  v-if="columnActive.includes('Cost Element (GL Protein) Desc')"
                >
                  <span v-if="val.taxonomy">
                    {{
                      val.taxonomy.costElement
                        ? val.taxonomy.costElement.desc || '-'
                        : '-'
                    }}
                  </span>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td v-if="columnActive.includes('Material Group')">
                  {{ val.taxonomy ? val.taxonomy.mat_group || '-' : '-' }}
                </td>
                <td v-if="columnActive.includes('Nature Activity')">
                  <template v-if="val.taxonomy">
                    <span v-if="val.taxonomy.costCenter">
                      {{
                        val.taxonomy.costCenter.costNature
                          ? val.taxonomy.costCenter.costNature.nature_activity
                          : '-'
                      }}
                    </span>
                    <span v-else>{{ '-' }}</span>
                  </template>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td
                  v-if="columnActive.includes('Taxonomy Category')"
                  class="text-capitalize"
                >
                  <template v-if="val.taxonomy">
                    <span v-if="val.taxonomy.costCenter">
                      {{
                        val.taxonomy.costCenter.costNature
                          ? val.taxonomy.costCenter.costNature.category || '-'
                          : '-'
                      }}
                    </span>
                    <span v-else>{{ '-' }}</span>
                  </template>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td
                  v-if="columnActive.includes('Working/Non Working')"
                  class="text-capitalize"
                >
                  <span v-if="val.taxonomy">
                    {{
                      val.taxonomy.costCenter
                        ? val.taxonomy.costCenter.type || '-'
                        : '-'
                    }}
                  </span>
                  <span v-else>{{ '-' }}</span>
                </td>
                <td
                  v-if="columnActive.includes('Method')"
                  class="text-capitalize"
                >
                  {{ val ? val.method : '-' }}
                </td>
                <td v-if="columnActive.includes('Campaign')">
                  {{ val ? val.campaign : '-' }}
                </td>
                <td v-if="columnActive.includes('BPC Line')">
                  {{ val.taxonomy ? val.taxonomy.bpc || '-' : '-' }}
                </td>
                <td v-if="columnActive.includes('Start')">
                  {{ val.start ? formatDate(val.start) : '-' }}
                </td>
                <td v-if="columnActive.includes('End')">
                  {{ val.end ? formatDate(val.end) : '-' }}
                </td>
                <td
                  v-if="
                    columnActive.includes('Investment Type') &&
                      isLoggedInAsSales
                  "
                >
                  {{ val.investment_type ? val.investment_type : '-' }}
                </td>
                <td v-if="columnActive.includes('Activity Description')">
                  {{ val.activity_desc ? val.activity_desc : '-' }}
                </td>
                <template v-for="(amount, iAmount) in val.amount">
                  <td
                    v-if="columnActive.includes(amount.title)"
                    :key="'amount' + iAmount"
                    class="text-right"
                  >
                    <span v-if="amount">
                      {{ amount.value ? idr(amount.value) : '-' }}
                    </span>
                    <span v-else>
                      -
                    </span>
                  </td>
                </template>
                <td v-if="columnActive.includes('PO')" class="text-right">
                  {{ val.po ? idr(val.po) : '-' }}
                </td>
                <td v-if="columnActive.includes('Non-PO')" class="text-right">
                  {{ val.non_po ? idr(val.non_po) : '-' }}
                </td>
                <td
                  v-if="columnActive.includes('Remaining IO')"
                  class="text-right"
                >
                  {{ val.remainingIO ? idr(val.remainingIO) : '-' }}
                </td>
                <td v-if="columnActive.includes('GR')" class="text-right">
                  {{ val.gr ? idr(val.gr) : '-' }}
                </td>
                <td
                  v-if="columnActive.includes('Actual Non-PO')"
                  class="text-right"
                >
                  {{ val.actualNonPO ? idr(val.actualNonPO) : '-' }}
                </td>
                <td
                  v-if="columnActive.includes('Remaining PO')"
                  class="text-right"
                >
                  {{ val.remainingPO ? idr(val.remainingPO) : '-' }}
                </td>
                <td
                  v-if="columnActive.includes('Remaining Non-PO')"
                  class="text-right"
                >
                  {{ val.remainingNonPO ? idr(val.remainingNonPO) : '-' }}
                </td>
                <td
                  v-if="columnActive.includes('Status')"
                  class="text-uppercase"
                >
                  {{ val.status || '-' }}
                </td>
                <td v-if="columnActive.includes('Details')" class="text-center">
                  <modal-rejectIO
                    :item="val"
                    :isIO="true"
                    type="io"
                    :page="page"
                  />
                </td>
                <!-- kolom edit & modify -->
                <td
                  v-if="
                    (isEditable || isReviseable) &&
                      hasPermission('create_spending', 'create')
                  "
                >
                  <v-btn
                    x-small
                    class="ma-2 white--text"
                    fab
                    color="secondblue"
                    :disabled="isDisableButton(val.status.toLowerCase())"
                    @click="modalEdit(val.id, val.status.toLowerCase())"
                  >
                    <v-icon x-small>mdi-square-edit-outline</v-icon>
                  </v-btn>
                </td>
                <!-- kolom modify revise -->
                <!-- <td
                  v-else-if="
                    isReviseable &&
                      hasPermission('create_spending', 'create') &&
                      isActiveRevise
                  "
                >
                  <v-btn
                    x-small
                    class="ma-2 white--text"
                    fab
                    color="secondblue"
                    :disabled="isDisableButton(val.status.toLowerCase())"
                    @click="modalEdit(val.id, 'revise')"
                  >
                    <v-icon x-small>mdi-square-edit-outline</v-icon>
                  </v-btn>
                </td> -->
                <!-- kolom cancel -->
                <td
                  v-if="
                    isActionable && hasPermission('create_spending', 'create')
                  "
                >
                  <v-btn
                    x-small
                    class="white--text"
                    block
                    :color="
                      val.status === 'cancelled' ? 'menuActive' : 'primary'
                    "
                    @click="cancelIO(val)"
                    :disabled="
                      submitableDiv
                        ? !checkCancel(val.status.toLowerCase())
                        : isCancelable
                    "
                  >
                    {{ val.status === 'cancelled' ? 'Uncancel' : 'Cancel' }}
                  </v-btn>
                </td>
              </tr>
              <tr class="bgTotal">
                <td
                  v-if="singleSubmit"
                  class="sticky-body1_ border-r-0 sticky-amount"
                  style="z-index: 2 !important"
                ></td>
                <td
                  v-if="columnActive.includes('IO Number')"
                  class="border-r-0 font-weight-bold text-right sticky-amount"
                  style="z-index: 2 !important"
                  :class="[singleSubmit ? 'sticky-body2_' : 'sticky-body1']"
                  :style="
                    columnActive.includes('Code')
                      ? ''
                      : 'border-right: 1px solid #0000001f !important;'
                  "
                >
                  {{ columnActive.includes('Code') ? '' : 'TOTAL' }}
                </td>
                <td
                  v-if="columnActive.includes('Code')"
                  class="font-weight-bold text-right border-x-0  sticky-amount"
                  style="z-index: 2 !important"
                  :style="
                    columnActive.includes('IO Number')
                      ? 'border-right: 1px solid #0000001f !important;'
                      : ''
                  "
                  :class="[
                    columnActive.includes('IO Number') && !singleSubmit
                      ? 'sticky-body2-spending'
                      : '',
                    columnActive.includes('IO Number') && singleSubmit
                      ? 'sticky-body3_'
                      : 'sticky-body2'
                  ]"
                >
                  {{ columnActive.includes('IO Number') ? 'TOTAL' : '' }}
                </td>
                <td
                  v-if="columnActive.includes('Entity')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Brand')"
                  class="border-x-0 sticky-amount"
                ></td>
                <template
                  v-for="(groupContent, iGroupContent) in dataItems[0].group"
                >
                  <td
                    v-if="columnActive.includes(groupContent.title.name)"
                    :key="'groupContent-' + iGroupContent"
                    class="border-x-0 sticky-amount"
                  ></td>
                </template>
                <td
                  v-if="columnActive.includes('Product Hierarchy')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Budget Owner')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="isLoggedInAsSales && columnActive.includes('Channel')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="isLoggedInAsSales && columnActive.includes('Account')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('PIC')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Cost Center Description')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Cost Center')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Cost Element (GL Protein)')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Cost Element (GL Protein) Desc')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Material Group')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Nature Activity')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Taxonomy Category')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Working/Non Working')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Method')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Campaign')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('BPC Line')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Start')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('End')"
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="
                    isLoggedInAsSales &&
                      columnActive.includes('Investment Type')
                  "
                  class="border-x-0 sticky-amount"
                ></td>
                <td
                  v-if="columnActive.includes('Activity Description')"
                  class="border-x-0 text-right font-weight-bold sticky-amount"
                >
                  {{ columnActive.includes('IO Number') ? '' : 'TOTAL' }}
                </td>
                <template v-for="(amount, iAmount) in dataItems[0].amount">
                  <td
                    v-if="columnActive.includes(amount.title)"
                    :key="'amount' + iAmount"
                    class="font-weight-bold text-right sticky-amount"
                  >
                    {{ totalAmount(amount.title) }}
                  </td>
                </template>
                <td
                  v-if="columnActive.includes('PO')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('po') }}
                </td>
                <td
                  v-if="columnActive.includes('Non-PO')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('non_po') }}
                </td>
                <td
                  v-if="columnActive.includes('Remaining IO')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('remainingIO') }}
                </td>
                <td
                  v-if="columnActive.includes('GR')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('gr') }}
                </td>
                <td
                  v-if="columnActive.includes('Actual Non-PO')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('actualNonPO') }}
                </td>
                <td
                  v-if="columnActive.includes('Remaining PO')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('remainingPO') }}
                </td>
                <td
                  v-if="columnActive.includes('Remaining Non-PO')"
                  class="font-weight-bold text-right sticky-amount"
                >
                  {{ totalAmountFor('remainingNonPO') }}
                </td>
                <td
                  v-if="columnActive.includes('Status')"
                  class="sticky-amount border-x-0"
                ></td>
                <td
                  v-if="
                    (isActionable || isReviseable) &&
                      hasPermission('create_spending', 'create')
                  "
                  class="sticky-amount border-x-0"
                ></td>
                <!-- <td
                  v-if="
                    isReviseable &&
                      hasPermission('create_spending', 'create') &&
                      isActiveRevise
                  "
                  class="sticky-amount border-x-0"
                ></td> -->
                <td
                  v-if="columnActive.includes('Details')"
                  class="sticky-amount border-x-0"
                ></td>
                <td
                  v-if="
                    isActionable && hasPermission('create_spending', 'create')
                  "
                  class="sticky-amount border-x-0"
                ></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td :colspan="spendingColumn.length" class="text-center pt-2">
                  <span>No Data Displayed</span>
                </td>
              </tr>
            </tbody>
          </v-perfect-scroll>
        </template>
      </v-simple-table>
      <v-flex xs12 class="text-right px-2 pr-0 pb-2" v-if="page == 'approval'">
        <v-btn
          class="ma-2 white--text"
          color="#bd1e19"
          :disabled="dataItem.selected.length < 1"
          @click="rejectIO()"
        >
          Reject
        </v-btn>
        <v-btn
          primary
          class="primary ma-2 mr-0"
          :disabled="dataItem.selected.length < 1"
          @click="approveIO()"
        >
          Approve
        </v-btn>
      </v-flex>
      <v-flex
        xs12
        class="pt-2 text-right px-2 pr-0 pb-2"
        v-if="isActionable && hasPermission('create_spending', 'create')"
      >
        <v-btn
          v-if="submitableDiv ? true : !isCancelable"
          primary
          class="primary ma-2 mr-0"
          @click="confirmSubmit()"
        >
          Submit
        </v-btn>
      </v-flex>
    </v-col>
    <v-dialog v-model="dialogEdit" max-width="80%" @keyup.esc="closeEdit">
      <v-card>
        <v-card-title class="primary white--text text-capitalize">
          <span
            >{{ statusEdit === 'edit' ? statusEdit : 'Modify' + ' ' }} IO</span
          >
        </v-card-title>
        <v-perfect-scroll
          class="drawer-menu--scrollEdit"
          :settings="scrollSettingsEdit"
        >
          <v-card-text class="px-9">
            <v-row>
              <v-col cols="12" class="px-0 pt-0">
                <table width="100%">
                  <tr>
                    <td class="font-weight-bold darkblue--text">
                      Code
                    </td>
                    <td>{{ spending ? spending.code : '-' }}</td>
                    <td class="font-weight-bold darkblue--text">Entity</td>
                    <td>
                      {{ spending.entity ? spending.entity.name : '-' }}
                    </td>
                    <td class="font-weight-bold darkblue--text">Brand</td>
                    <td>{{ spending.brand ? spending.brand.name : '-' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold darkblue--text">House</td>
                    <td>{{ spending.house ? spending.house.name : '-' }}</td>
                    <td class="font-weight-bold darkblue--text">Stage</td>
                    <td>
                      {{ spending.product ? spending.product.stage.name : '-' }}
                    </td>
                    <td class="font-weight-bold darkblue--text">
                      Budget Owner
                    </td>
                    <td>
                      {{
                        spending.budgetOwner ? spending.budgetOwner.desc : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold darkblue--text">PIC</td>
                    <td>{{ spending ? spending.pic : '-' }}</td>
                    <td class="font-weight-bold darkblue--text">
                      Cost Element
                    </td>
                    <td>
                      {{
                        spending.taxonomy
                          ? spending.taxonomy.costElement.desc
                          : '-'
                      }}
                    </td>
                    <td class="font-weight-bold darkblue--text">
                      Material Group
                    </td>
                    <td>
                      {{
                        spending.taxonomy ? spending.taxonomy.mat_group : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold darkblue--text">
                      Nature Activity
                    </td>
                    <td>
                      <template v-if="spending.taxonomy">
                        <span v-if="spending.taxonomy.costCenter">
                          {{
                            spending.taxonomy.costCenter.costNature
                              ? spending.taxonomy.costCenter.costNature
                                  .nature_activity
                              : '-'
                          }}
                        </span>
                        <span v-else>-</span>
                      </template>
                      <span v-else>-</span>
                    </td>
                    <td class="font-weight-bold darkblue--text">
                      Taxonomy Category
                    </td>
                    <td colspan="3">
                      <template v-if="spending.taxonomy">
                        <span v-if="spending.taxonomy.costCenter">
                          {{
                            spending.taxonomy.costCenter.costNature
                              ? spending.taxonomy.costCenter.costNature.category
                              : '-'
                          }}
                        </span>
                        <span v-else>-</span>
                      </template>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <ValidationProvider
                  name="Product Hierarchy"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Product Hierarchy</label>
                  <v-autocomplete
                    id="productHierarchy"
                    single-line
                    outlined
                    label="Select Product"
                    v-model="spending.product"
                    dense
                    required
                    :items="product_hierarchies"
                    item-text="material_desc"
                    return-object
                    :error-messages="errors"
                    :disabled="spending.io_number ? true : false"
                    autocomplete
                    hide-details
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <ValidationProvider
                  name="Cost Center"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Cost Center</label>
                  <v-autocomplete
                    id="costCenter"
                    single-line
                    outlined
                    label="Select Cost Center"
                    required
                    v-model="spending.taxonomy"
                    :items="taxonomies"
                    item-text="costCenter.desc"
                    return-object
                    dense
                    :error-messages="errors"
                    :disabled="spending.io_number ? true : false"
                    autocomplete
                    hide-details
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <ValidationProvider
                  name="Working/Non Working"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Working/Non Working</label>
                  <v-select
                    dense
                    id="costCenter"
                    single-line
                    v-model="spending.taxonomy.costCenter.type"
                    outlined
                    label="Select Working/Non Working"
                    required
                    item-text="name"
                    item-value="value"
                    :items="pillars"
                    :error-messages="errors"
                    disabled
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <ValidationProvider
                  name="Method"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Method</label>
                  <v-select
                    dense
                    id="costCenter"
                    single-line
                    v-model="spending.method"
                    outlined
                    label="Select Method"
                    required
                    item-text="name"
                    item-value="value"
                    :items="methods"
                    :error-messages="errors"
                    :disabled="spending.io_number ? true : false"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <ValidationProvider
                  name="Campaign"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Campaign</label>
                  <v-text-field
                    id="campaign"
                    single-line
                    outlined
                    dense
                    label="Campaign"
                    v-model="spending.campaign"
                    required
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <label class="darkblue--text">Start</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <ValidationProvider
                      name="Start"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        dense
                        id="start"
                        v-model="spending.start"
                        type="date"
                        label="Picker in Menu"
                        prepend-inner-icon="event"
                        readonly
                        single-line
                        outlined
                        v-on="on"
                        :error-messages="errors"
                        hide-details
                      ></v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    type="date"
                    v-model="spending.start"
                    no-title
                    scrollable
                    id="spendingDate"
                    :min="minDate"
                    :max="maxDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <label class="darkblue--text">End</label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <ValidationProvider
                      name="End"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        dense
                        id="end"
                        v-model="spending.end"
                        type="date"
                        label="Picker in Menu"
                        prepend-inner-icon="event"
                        readonly
                        single-line
                        outlined
                        v-on="on"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    type="date"
                    v-model="spending.end"
                    no-title
                    scrollable
                    id="spendingDate"
                    :min="minDate"
                    :max="maxDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0" v-if="isLoggedInAsSales">
                <ValidationProvider
                  name="Investment Type"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Investment Type</label>
                  <v-select
                    dense
                    id="investment_type"
                    single-line
                    v-model="spending.investment_type"
                    outlined
                    label="Select Investment Type"
                    required
                    item-text="name"
                    item-value="value"
                    :items="investment_types"
                    :error-messages="errors"
                    return-object
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="3" class="pl-0 pb-0">
                <ValidationProvider
                  name="Activity Description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Activity Description</label>
                  <v-text-field
                    id="activityDesc"
                    single-line
                    outlined
                    label="Activity Description"
                    v-model="spending.activity_desc"
                    required
                    :error-messages="errors"
                    dense
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col class="pl-0 pt-0" sm="12" v-if="isLoggedInAsSales">
                <form-channel
                  @saveChannel="saveChannel"
                  :account.sync="spending.ioAccount"
                  :channel.sync="spending.channels"
                />
              </v-col>
              <v-col cols="6" class="pa-0"> </v-col>
              <v-col cols="6" class="pa-0">
                <span v-if="validationMessage != ''" class="red--text fs-11">{{
                  validationMessage
                }}</span>
              </v-col>
            </v-row>
            <v-layout row wrap>
              <v-flex xs12>
                <h3 class="black--text">Amount</h3>
              </v-flex>
              <v-flex
                xs3
                v-for="(item, index) in spending.amount"
                :key="index"
                :class="
                  index === 3 || index === 7 || index === 11 ? '' : 'pr-3'
                "
              >
                <label class="darkblue--text">{{ item.month }}</label>
                <v-currency-field
                  :id="item.month"
                  :label="item.month"
                  single-line
                  v-model="item.value"
                  :item="spending.amount"
                  outlined
                  :disabled="item.month === 'Total' || monthCheck(item.month)"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 mb-3>
                <h3 class="black--text">Uploaded File</h3>
              </v-flex>
              <v-flex xs12 mb-3 v-if="supportDoc.length > 0">
                <v-simple-table class="spending-table nav-table">
                  <thead>
                    <tr>
                      <th width="70%" class="white--text">File Name</th>
                      <th colspan="2" class="white--text">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in supportDoc" :key="item.id">
                      <td width="70%">{{ item.file }}</td>
                      <td>
                        <v-btn
                          :loading="loading3"
                          small
                          color="thirdblue"
                          class="ma-2 white--text text-capitalize"
                          @click="downloadFile(item)"
                        >
                          Download
                          <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          :loading="loading4"
                          :disabled="loading4"
                          small
                          color="#bd1e19"
                          class="ma-2 white--text text-capitalize"
                          @click="fileRemoved(item.name)"
                        >
                          Remove
                          <v-icon right dark>delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-flex>
              <v-flex xs-12 mb-3 v-else class="greydark">
                <p class="text-center pt-3">No data displayed</p>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <h3 class="black--text my-2">Supporting Docs</h3>
                <span
                  >Only file types document .doc, .docx, .xls, .xlsx, .ppt,
                  .pptx, .pdf are allowed.</span
                >
              </v-flex>
              <v-layout row wrap class="upload-docs">
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 1
                    <!-- A & P Investment Breakdown -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone1"
                    id="'dropzone1'"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'AP'))"
                    @vdropzone-complete="onComplete($event, (name = 'AP'))"
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 2
                    <!-- Cost estimation & detail production plan -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone2"
                    id="'dropzone2'"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'Cost Estimate'))"
                    @vdropzone-complete="
                      onComplete($event, (name = 'Cost Estimate'))
                    "
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 3
                    <!-- Proposal   -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone3"
                    id="'dropzone3'"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'Proposal'))"
                    @vdropzone-complete="
                      onComplete($event, (name = 'Proposal'))
                    "
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 4
                    <!-- Storyboard -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone4"
                    id="dropzone4"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'Storyboard'))"
                    @vdropzone-complete="
                      onComplete($event, (name = 'Storyboard'))
                    "
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 5
                    <!-- Storyboard -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone5"
                    id="dropzone5"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'Media Schedule'))"
                    @vdropzone-complete="
                      onComplete($event, (name = 'Media Schedule'))
                    "
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 6
                    <!-- Storyboard -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone6"
                    id="dropzone6"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'Agreement'))"
                    @vdropzone-complete="
                      onComplete($event, (name = 'Agreement'))
                    "
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 7
                    <!-- Storyboard -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone7"
                    id="dropzone7"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'ROI'))"
                    @vdropzone-complete="onComplete($event, (name = 'ROI'))"
                  ></vue-dropzone>
                </v-flex>
                <v-flex md3 pa-3>
                  <label class="darkblue--text">
                    Document 8
                    <!-- Storyboard -->
                  </label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone8"
                    id="dropzone8"
                    :options="dropzoneOptions"
                    @vdropzone-reset="fileRemoved((name = 'Distribution'))"
                    @vdropzone-complete="
                      onComplete($event, (name = 'Distribution'))
                    "
                  ></vue-dropzone>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-perfect-scroll>
        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" class="mr-2" dark @click="closeDialogEdit()">
            Close
          </v-btn>
          <v-btn
            color="primary"
            @click="uploadFile()"
            :disabled="isDisabledAdd"
            :loading="isLoadEdit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog error approval restriction -->
    <v-dialog v-model="dialogErrorApproval" scrollable max-width="600px">
      <v-card class="py-3 pb-5">
        <v-flex class="text-center">
          <div
            class="swal2-icon swal2-error swal2-animate-error-icon"
            style="display: flex;"
          >
            <span class="swal2-x-mark">
              <span class="swal2-x-mark-line-left"></span>
              <span class="swal2-x-mark-line-right"></span>
            </span>
          </div>
          <h2 class="swal2-title" id="swal2-title">Failed!</h2>
          <p></p>
        </v-flex>
        <div class="swal2-content">
          <div id="swal2-content" style="display: block;">
            {{ approvalError.message }}
          </div>
        </div>
        <v-expansion-panels
          flat
          class="filterby-info mt-1"
          v-if="approvalError.listBONotApproved"
          v-model="panelListBO"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              class="primary--text fs-14 d-block text-center"
              height="100px"
            >
              {{ panelListBO === 0 ? 'Hide' : 'Show' }} Budget Owner List
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey--text">
              <v-simple-table class="spending-table nav-table px-8 mt-5">
                <template v-slot:default>
                  <thead>
                    <tr class="primary custom-table-header">
                      <th class="f-14 font-weight-500">
                        Budget Owner
                      </th>
                      <th class="f-14 font-weight-500">Approval Level</th>
                    </tr>
                  </thead>
                  <v-perfect-scroll
                    class="drawer-menu--scroll-approval"
                    :settings="scrollSettingsApproval"
                  >
                    <tbody v-if="approvalError.listBONotApproved.length > 0">
                      <tr
                        v-for="(item, index) in approvalError.listBONotApproved"
                        :key="'bo' + index"
                      >
                        <td class="fs-12">
                          {{ item.budget_owner }}
                        </td>
                        <td class="text-uppercase fs-12">
                          {{ item.approval_level }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="4" class="text-center pt-2">
                          <span>No Data Displayed</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-perfect-scroll>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="swal2-actions">
          <button
            type="button"
            class="swal2-confirm swal2-styled"
            style="display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214);"
            @click="dialogErrorApproval = false"
          >
            OK
          </button>
        </div>
      </v-card>
    </v-dialog>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import filterColumn from '../filterColumn';
import ProgressTracking from './ProgressTrackingDynamic';
import modalReject from '@/components/approval/modalRejectIO';
import Swal from 'sweetalert2';
import moment from 'moment';
import ACLMixin from '@/mixins/ACLMixin';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import formChannel from '@/components/formChannel';

export default {
  props: {
    dataItem: {
      type: Object
    },
    page: {
      type: String,
      default: ''
    },
    year: {
      type: Date
    },
    status: {
      type: String
    },
    filterBy: {
      type: String
    },
    submitableDiv: {
      type: Boolean,
      required: false
    }
  },
  mixins: [ACLMixin],
  data() {
    return {
      isLoadEdit: false,
      isActiveRevise: false,
      support_docs: {
        docs: [],
        name: [],
        file: []
      },
      pillars: [
        {
          name: 'Working',
          value: 'working'
        },
        {
          name: 'Non Working',
          value: 'non working'
        }
      ],
      methods: [
        {
          name: 'Traditional',
          value: 'traditional'
        },
        {
          name: 'Digital',
          value: 'digital'
        }
      ],
      statusEdit: '',
      loading3: false,
      loading4: false,
      menu: false,
      menu2: false,
      dialogEdit: false,
      dialogErrorApproval: false,
      panelListBO: null,
      approvalError: {
        message: '',
        listBONotApproved: []
      },
      spending: {},
      supportDoc: [],
      product_hierarchies: [],
      taxonomies: [],
      dataItems: [],
      dataItemsFull: [],
      columnActive: [],
      info: {},
      selectAll: true,
      progressDialogLoading: false,
      spendingColumn: [
        {
          title: 'IO Number',
          value: '',
          field: 'io_number',
          isCode: true
        },
        {
          title: 'Code',
          value: '',
          field: 'code',
          isCode: true
        },
        {
          title: 'Entity',
          value: '',
          field: 'brand.entity.name',
          isCode: false
        },
        {
          title: 'Brand',
          value: '',
          field: 'brand.name',
          isCode: false
        },
        {
          title: 'Product Hierarchy',
          value: '',
          field: 'product.name',
          isCode: false
        },
        {
          title: 'Budget Owner',
          value: '',
          field: 'budgetOwner.desc',
          isCode: false
        },
        {
          title: 'PIC',
          value: '',
          field: 'pic',
          isCode: false
        },
        {
          title: 'Cost Center Description',
          value: '',
          field: 'taxonomy.costCenter.desc',
          isCode: false
        },
        {
          title: 'Cost Center',
          value: '',
          field: 'taxonomy.costCenter.code',
          isCode: true
        },
        {
          title: 'Cost Element (GL Protein)',
          value: '',
          field: 'taxonomy.costElement.code',
          isCode: true
        },
        {
          title: 'Cost Element (GL Protein) Desc',
          value: '',
          field: 'taxonomy.costElement.desc',
          isCode: false
        },
        {
          title: 'Material Group',
          value: '',
          field: 'taxonomy.mat_group',
          isCode: false
        },
        {
          title: 'Nature Activity',
          value: '',
          field: 'taxonomy.costCenter.costNature.nature_activity',
          isCode: false
        },
        {
          title: 'Taxonomy Category',
          value: '',
          field: 'taxonomy.costCenter.costNature.category',
          isCode: false
        },
        {
          title: 'Working/Non Working',
          value: '',
          field: 'taxonomy.costCenter.type',
          isCode: false
        },
        {
          title: 'Method',
          value: '',
          field: 'method',
          isCode: false
        },
        {
          title: 'Campaign',
          value: '',
          field: 'campaign',
          isCode: false
        },
        {
          title: 'BPC Line',
          value: '',
          field: 'taxonomy.bpc',
          isCode: false
        },
        {
          title: 'Start',
          value: '',
          field: 'start',
          isCode: false,
          isDate: true
        },
        {
          title: 'End',
          value: '',
          field: 'end',
          isCode: false,
          isDate: true
        },
        {
          title: 'Activity Description',
          value: '',
          field: 'activity_desc',
          isCode: false
        },
        {
          title: 'PO',
          value: '',
          field: 'po',
          isCode: false,
          columnType: true
        },
        {
          title: 'Non-PO',
          value: '',
          field: 'non_po',
          isCode: false,
          columnType: true
        },
        {
          title: 'Remaining IO',
          value: '',
          field: 'remainingIO',
          isCode: false,
          columnType: true
        },
        {
          title: 'GR',
          value: '',
          field: 'gr',
          isCode: false,
          columnType: true
        },
        {
          title: 'Actual Non-PO',
          value: '',
          field: 'actualNonPO',
          isCode: false,
          columnType: true
        },
        {
          title: 'Remaining PO',
          value: '',
          field: 'remainingPO',
          isCode: false,
          columnType: true
        },
        {
          title: 'Remaining Non-PO',
          value: '',
          field: 'remainingNonPO',
          isCode: false,
          columnType: true
        },
        {
          title: 'Status',
          value: '',
          field: 'status',
          isCode: false
        }
      ],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsEdit: {
        maxScrollbarLength: 220
      },
      scrollSettingsFilter: {
        maxScrollbarLength: 283
      },
      stepItem: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        timeout: 100000,
        thumbnailWidth: 150,
        acceptedFiles:
          '.xlsx, .xls, .XLS, .XLSX, .doc, .DOC, .docx, .DOCX, .pdf, .PDF, .ppt, .PPT, .pptx, .PPTX',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      activeMonth: [],
      isDisabledAdd: false,
      validationMessage: '',
      channels: [],
      isCancel: false,
      showAdhoc: false
    };
  },
  components: {
    'progress-dialog': ProgressDialog,
    'filter-column': filterColumn,
    'tracking-progress': ProgressTracking,
    'modal-rejectIO': modalReject,
    vueDropzone: vue2Dropzone,
    'form-channel': formChannel
  },
  computed: {
    validationAccount() {
      if (this.isLoggedInAsSales && this.spending.ioAccount.length > 0) {
        return true;
      } else if (
        this.isLoggedInAsSales &&
        this.spending.ioAccount.length === 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    tableStatus() {
      return this.getFiltered('status');
    },
    isReviseable() {
      let acceptedStatus = this.submitableDiv
        ? ['approved', 'to modify', 'rejected', 'draft']
        : ['approved', 'to modify'];
      let arr = this.tableStatus.some(
        r => acceptedStatus.indexOf(r.toLowerCase()) >= 0
      );
      return arr;
    },
    isEditable() {
      let acceptedStatus = ['draft', 'to modify', 'rejected', 'cancelled', '-'];
      let arr = this.tableStatus.some(
        r => acceptedStatus.indexOf(r.toLowerCase()) >= 0
      );
      return arr;
    },
    isSubmitable() {
      let acceptedStatus = [
        'approved',
        'to modify',
        'rejected',
        '-',
        'draft',
        'cencelled'
      ];
      let arr = this.tableStatus.some(
        r => acceptedStatus.indexOf(r.toLowerCase()) >= 0
      );
      return arr;
    },
    singleSubmit() {
      // && singleSubmit (ngambil dari api)
      if (
        this.page == 'approval' ||
        (this.page == 'report' &&
          this.isLoggedInAsBO &&
          this.isSubmitable &&
          this.dataItem.single_flow)
      )
        return true;
      return false;
    },
    isActionable() {
      let statusCancel = ['draft', 'rejected', 'to modify', 'cancelled'];
      let statusRevise = ['approved', 'to modify', 'cancelled'];
      let statusAdhoc = ['approved', 'rejected', 'adhoc', 'cancelled'];
      let isCanceled = this.tableStatus.some(
        r => statusCancel.indexOf(r.toLowerCase()) >= 0
      );
      let isRevise = this.tableStatus.some(
        r => statusRevise.indexOf(r.toLowerCase()) >= 0
      );
      let isAdhoc = this.tableStatus.some(
        r => statusAdhoc.indexOf(r.toLowerCase()) >= 0
      );
      if (isCanceled) {
        return true;
      } else if (isRevise && this.isActiveRevise) {
        return true;
      } else if (isAdhoc && this.showAdhoc) {
        return true;
      } else {
        return false;
      }
    },
    isCancelable() {
      return this.status === 'approval process' ? true : false;
    },
    minDate() {
      let startYear = moment(this.spending.year).format('YYYY');
      return startYear + '-01-01';
    },
    maxDate() {
      let endYear = moment(this.spending.year).format('YYYY');
      return endYear + '-12-31';
    }
  },
  watch: {
    isActiveRevise(val) {
      this.isActiveRevise = val;
    },
    columnActive(val) {
      if (val.length !== this.spendingColumn.length) {
        this.selectAll = false;
      } else {
        this.selectAll = true;
      }
    },
    spendingColumn: {
      handler(newVal) {
        this.spendingColumn = newVal;
      }
    },
    dataItem(val) {
      this.info = val.header;
      this.stepItem = val.stepItem;
      this.dataItems = val.children.map(itemdata => {
        itemdata.group = itemdata.group.map(itemgroup => {
          return {
            ...itemgroup,
            field: 'resultGroup.' + itemgroup.title
          };
        });
        itemdata.amount = itemdata.amount.map(itemamount => {
          return {
            ...itemamount,
            field: 'result.' + itemamount.title,
            columnType: true
          };
        });
        return { ...itemdata };
      });
      this.dataItemsFull = this.dataItems;
    },
    status(val) {
      if (
        val.toLowerCase() === 'aprroved' ||
        val.toLowerCase() === 'to modify'
      ) {
        this.reviseCheck();
      }
    },
    'spending.start'(val) {
      this.dateCheck(val, this.spending.end);
    },
    'spending.end'(val) {
      this.dateCheck(this.spending.start, val);
    },
    activeMonth(val) {
      for (let i = 0; i < this.spending.amount.length; i++) {
        if (!val.includes(this.spending.amount[i].month)) {
          if (this.spending.amount[i].month !== 'Total') {
            this.spending.amount[i].value = 0;
          }
        }
      }
    }
  },
  mounted() {
    if (Object.keys(this.dataItem).length > 0) {
      this.info = this.dataItem.header;
      this.stepItem = this.dataItem.stepItem;
      this.dataItems = this.dataItem.children.map(itemdata => {
        itemdata.group = itemdata.group.map(itemgroup => {
          return {
            ...itemgroup,
            field: 'resultGroup.' + itemgroup.title.name
          };
        });
        itemdata.amount = itemdata.amount.map(itemamount => {
          return {
            ...itemamount,
            field: 'result.' + itemamount.title,
            columnType: true
          };
        });
        return { ...itemdata };
      });
      this.dataItemsFull = this.dataItems;
      if (this.dataItem.children.length > 0) {
        this.pushColumn();
      }
    }
    this.handleRefresh();
    this.firstColumnActive();
    if (this.isReviseable) {
      this.reviseCheck();
    }
    if (this.isLoggedInAsSales) {
      this.getInvestmentType();
    }
  },
  methods: {
    getInvestmentType() {
      this.$store
        .dispatch('investmentType/getAll', { paginate: false })
        .then(data => {
          if (data.code === 200) {
            this.investment_types = data.data;
          }
        });
    },
    isDisableButton(val) {
      let reviseOn =
        val.includes('approval') || val === 'cancelled' ? true : false;
      let reviseOff =
        val.includes('approval') ||
        val === 'cancelled' ||
        val.includes('approved')
          ? true
          : false;
      if (this.page === 'report')
        return this.isActiveRevise ? reviseOn : reviseOff;
      return false;
    },
    checkCancel(item) {
      let statusCancel = ['draft', 'rejected', 'to modify', 'cancelled'];
      let statusRevise = ['approved', 'to modify', 'cancelled'];
      let statusAdhoc = ['approved', 'rejected', 'adhoc', 'cancelled'];
      if (
        statusCancel.includes(item) ||
        (statusRevise.includes(item) && this.isActiveRevise) ||
        (statusAdhoc.includes(item) && this.showAdhoc)
      ) {
        this.isCancel = true;
        return true;
      } else {
        this.isCancel = false;
        return false;
      }
    },
    cancelIO(item) {
      let text = item.status === 'cancelled' ? 'uncancel' : 'cancel';
      let endpoint =
        item.status === 'cancelled'
          ? 'spending/uncancelIO'
          : 'spending/cancelIO';
      Swal.fire({
        title: '',
        text: `Are you sure want to ${text} this spending?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          let params = {
            io_codes: Array(item.code.toString())
          };
          this.$store
            .dispatch(endpoint, params)
            .then(data => {
              this.progressDialogLoading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            text === 'cancel'
              ? ' Data cancellation cancelled'
              : 'Data uncancellation cancelled',
            'error'
          );
        }
      });
    },
    saveChannel(item) {
      this.spending.ioAccount = item.account;
      this.spending.channel = item.channel;
    },
    monthCheck(val) {
      let isMonth = this.activeMonth.includes(val);
      return !isMonth;
    },
    dateCheck(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      let today = new Date();
      today.setHours(0, 0, 0);
      if (startDate > endDate) {
        this.validationMessage = 'Start Date must be earlier than End Date.';
        this.isDisabledAdd = true;
      } else {
        this.validationMessage = '';
        this.isDisabledAdd = false;
      }
      let setEndDate = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        this.daysInMonth(endDate.getMonth() + 1, endDate.getFullYear())
      );
      if (end.slice(5, 7) === '02') {
        setEndDate = new Date(setEndDate.setMonth(1));
      }
      this.activeMonth = [];
      let tempStart = moment(startDate);
      let tempEnd = moment(setEndDate);
      while (tempStart.isSameOrBefore(tempEnd)) {
        this.activeMonth.push(tempStart.format('MMMM'));
        tempStart.add(1, 'month');
      }
    },
    downloadSpending() {
      let id = this.dataItem.groupActive;
      let year = moment(this.year).format('YYYY');
      let divisionId = this.dataItems[0].division_id;
      window.open(
        this.baseUrl +
          '/v1/io/export/report/spending?filterBy=budgetOwner&id=' +
          id +
          '&year=' +
          year +
          '&divisionId=' +
          divisionId +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    downloadByIO(item) {
      let id = item.groupActive;
      let year = moment(this.year).format('YYYY');
      window.open(
        this.baseUrl +
          '/v1/io/export/excel?filterBy=budgetOwner&id=' +
          id +
          '&year=' +
          year +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    reviseCheck() {
      return this.$store
        .dispatch('configuration/checkActive')
        .then(data => {
          if (data.code === 200) {
            this.isActiveRevise = data.data.is_active;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    downloadFile(item) {
      let file = encodeURIComponent(item.file);
      window.open(
        this.baseUrl +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    confirmEdit() {
      if (this.validationAccount) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to edit this spending?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.edit();
            this.isLoadEdit = true;
          }
        });
      } else {
        Swal.fire('Failed!', 'The Account field is required', 'error');
      }
    },
    closeDialogEdit() {
      this.dialogEdit = false;
      this.$refs.myVueDropzone1.removeAllFiles();
      this.$refs.myVueDropzone2.removeAllFiles();
      this.$refs.myVueDropzone3.removeAllFiles();
      this.$refs.myVueDropzone4.removeAllFiles();
      this.$refs.myVueDropzone5.removeAllFiles();
      this.$refs.myVueDropzone6.removeAllFiles();
      this.$refs.myVueDropzone7.removeAllFiles();
      this.$refs.myVueDropzone8.removeAllFiles();
    },
    edit() {
      let suppDocs = this.supportDoc.map(item => {
        return {
          io_code: this.spending.code,
          name: item.name,
          file: item.file
        };
      });
      let body = {
        spending_id: this.spending ? this.spending.id : null,
        entity_id: this.spending ? this.spending.entity_id : null,
        brand_id: this.spending.brand ? this.spending.brand.id : null,
        house_id: this.spending.house ? this.spending.house.id : null,
        product_id: this.spending.product ? this.spending.product.id : null,
        budget_owner_id: this.spending.budgetOwner
          ? this.spending.budgetOwner.id
          : null,
        pic: this.spending ? this.spending.pic : null,
        code: this.spending ? this.spending.code : null,
        taxonomy_code: this.spending.taxonomy
          ? this.spending.taxonomy.code
          : null,
        pillars: this.spending ? this.spending.pillars : null,
        method: this.spending ? this.spending.method : null,
        campaign: this.spending ? this.spending.campaign : null,
        start: this.spending ? this.spending.start : null,
        end: this.spending ? this.spending.end : null,
        investment_type: this.spending ? this.spending.investment_type : null,
        activity_desc: this.spending ? this.spending.activity_desc : null,
        amount: this.spending ? this.spending.amount : null,
        support_docs: suppDocs,
        status: this.statusEdit,
        account:
          this.spending.ioAccount.length > 0
            ? this.spending.ioAccount.map(item => {
                return item.id ? item.id : item.account.id;
              })
            : null
      };
      this.$store
        .dispatch('spending/edit', body)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.isLoadEdit = false;
            this.closeDialogEdit();
            Swal.fire('Success!', 'Spending successfully edited', 'success');
            this.support_docs = {
              docs: [],
              name: [],
              file: []
            };
            this.getData();
          } else {
            this.isLoadEdit = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadEdit = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    onComplete(file, name) {
      var fileType = file.upload.filename.split('.').pop();
      var fileTypes = [
        'xlsx',
        'xls',
        'XLS',
        'XLSX',
        'doc',
        'DOC',
        'docx',
        'DOCX',
        'pdf',
        'PDF',
        'ppt',
        'PPT',
        'pptx',
        'PPTX'
      ];
      if (fileTypes.includes(fileType)) {
        if (file.size <= 15000000) {
          this.support_docs.docs.push(file);
          this.support_docs.name.push(name);
          this.support_docs.file.push(file.upload.filename);
          if (this.support_docs.docs.length > 0) {
            this.btnDisabled = false;
          }
        } else {
          Swal.fire('Failed!', 'File size can not more than 15 mb', 'error');
        }
      } else {
        Swal.fire(
          'Failed!',
          'Only file types document .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf are allowed.',
          'error'
        );
      }
    },
    fileRemoved(name) {
      var indexFile = this.supportDoc.indexOf(name);
      var indexSupp = this.support_docs.name.indexOf(name);
      this.supportDoc.splice(indexFile, 1);
      this.support_docs.docs.splice(indexSupp, 1);
      this.support_docs.file.splice(indexSupp, 1);
      this.support_docs.name.splice(indexSupp, 1);
      if (this.supportDoc.length > 0) {
        this.btnDisabled = true;
      }
    },
    uploadFile() {
      if (this.support_docs.docs.length > 0) {
        this.isLoadEdit = true;
        let body = {
          io_code: this.spending.code
        };
        const payload = new FormData();
        Object.keys(body).forEach(key => {
          payload.append(key, body[key]);
        });
        Array.from(this.support_docs.docs).forEach(file => {
          payload.append('docs[]', file);
        });
        this.$store
          .dispatch('spending/uploadDocs', payload)
          .then(data => {
            this.isLoadEdit = false;
            if (data.code === 200) {
              this.btnDisabled = true;
              const uploadedSupportDocs = data.data.map(item => ({
                io_code: item.ioCode,
                file: item.nameFile
              }));
              this.supportDoc = [...this.supportDoc, ...uploadedSupportDocs];

              Swal.fire('Success!', data.message.text_en, 'success');
              this.confirmEdit();
            } else {
              this.isLoadEdit = false;
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.data.error, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.confirmEdit();
      }
    },
    modalEdit(id, status) {
      if (this.isActiveRevise)
        this.statusEdit = status === 'draft' ? 'edit' : 'revise';
      else this.statusEdit = 'edit';
      this.progressDialogLoading = true;
      this.loading = true;
      let param = {
        spending_id: id
      };
      this.$store
        .dispatch('spending/detail', param)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.spending = data.data.dataIO;
            this.spending.amount.map(item => {
              if (item.value === null) {
                item.value = 0;
              }
              return item;
            });
            this.supportDoc = data.data.supportDoc;
            this.spending.start = moment(this.spending.start).format(
              'YYYY-MM-DD'
            );
            this.spending.end = moment(this.spending.end).format('YYYY-MM-DD');
            this.spending.channel = '';
            this.getProduct();
            this.getTaxonomy();
            if (this.isLoggedInAsSales) {
              this.getChannel();
            }
            this.dialogEdit = true;
          } else {
            Swal.fire('Failed!', data.response.data.data.error, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getProduct() {
      if (this.spending.brand_id) {
        let params = {
          brand_id: this.spending.brand.id
        };
        this.$store
          .dispatch('spending/getProduct', params)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.product_hierarchies = data.data;
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          });
      } else {
        Swal.fire('Failed!', 'Brand is null', 'error');
      }
    },
    getTaxonomy() {
      let limit = 10000;
      this.$store
        .dispatch('taxonomy/getAll', { limit })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.taxonomies = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getChannel() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('channel/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.channels = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    confirmSubmit() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to submit this spending draft?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.submitSpending();
        }
      });
    },
    submitSpending() {
      this.progressDialogLoading = true;
      this.loading = true;
      let spendingDraft = this.singleSubmit
        ? this.dataItem.selected.filter(item => {
            return item !== '';
          })
        : this.dataItems.filter(val => {
            return val.status !== 'cancelled';
          });
      if (spendingDraft.length > 0) {
        let body = {
          spending_ids: this.singleSubmit
            ? spendingDraft
            : spendingDraft.map(val => {
                return val.id;
              }),
          year: moment(this.year).format('YYYY')
        };
        this.$store
          .dispatch('spendingDynamic/submitIO', body)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', 'Spending has been submitted', 'success');
              this.getData();
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          });
      } else {
        this.progressDialogLoading = false;
        Swal.fire(
          'Failed!',
          `${
            this.singleSubmit
              ? 'No data selected. Please select at least one data.'
              : 'IO status cancelled.'
          }`,
          'error'
        );
      }
    },
    rejectIO() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to reject this spending?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          let params = {
            spending_ids: this.dataItem.selected,
            year: moment(this.year).format('YYYY')
          };
          this.$store
            .dispatch('approval/rejectIO', params)
            .then(data => {
              this.progressDialogLoading = false;
              this.panel = [];
              if (data.code === 200) {
                Swal.fire({
                  title: 'Success!',
                  text: data.message.text_en,
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'OK'
                }).then(resultData => {
                  if (resultData.value) {
                    this.getData();
                  }
                });
              } else {
                if (data) {
                  Swal.fire(
                    'Failed!',
                    data.response.data.message.text_en,
                    'error'
                  );
                } else {
                  Swal.fire('Failed!', 'Please try again', 'error');
                }
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.message.text_en, 'error');
              this.getData();
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      });
    },
    approveIO() {
      let isApprove = this.dataItem.single_flow
        ? this.dataItem.selected.length > 0
          ? true
          : false
        : this.dataItem.selected.length === this.dataItem.children.length
        ? true
        : false;
      if (isApprove) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to approve this spending?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            this.progressDialogLoading = true;
            let params = {
              spending_ids: this.dataItem.selected,
              budget_owner_id: this.dataItem.children[0].budget_owner_id,
              year: moment(this.year).format('YYYY')
            };
            this.$store
              .dispatch('approval/approveIO', params)
              .then(data => {
                this.progressDialogLoading = false;
                this.panel = [];
                if (data.code === 200) {
                  Swal.fire({
                    title: 'Success!',
                    text: data.message.text_en,
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                  }).then(resultData => {
                    if (resultData.value) {
                      this.getData();
                    }
                  });
                } else {
                  if (data) {
                    this.dialogApproval(data.response.data);
                  } else {
                    Swal.fire('Failed!', 'Please try again', 'error');
                  }
                }
              })
              .catch(err => {
                Swal.fire('Failed!', err.response.message.text_en, 'error');
                this.getData();
                this.progressDialogLoading = false;
                this.loading = false;
              });
          }
        });
      } else {
        Swal.fire('Failed', 'You must select all IO to approve!', 'error');
      }
    },
    dialogApproval(data) {
      this.approvalError.message = data.message.text_en;
      if (data.data) {
        this.approvalError.listBONotApproved = data.data.listBONotApproved;
      } else {
        this.approvalError.listBONotApproved = [];
      }
      this.dialogErrorApproval = true;
    },
    getData() {
      this.$emit('getData');
    },
    selectAllIO() {
      this.dataItem.selected = [];
      if (!this.dataItem.selectAll) {
        for (let i in this.dataItem.children) {
          let statusIO = this.dataItem.children[i].status.toLowerCase();
          let notPushIO =
            (this.page == 'report' && statusIO.includes('approval')) ||
            (this.page == 'report' && statusIO == 'cancelled');
          this.dataItem.selected.push(
            notPushIO ? '' : this.dataItem.children[i].id
          );
        }
      }
    },
    totalAmount(month) {
      let amountTotal = this.dataItems
        .reduce((total, items) => {
          const value = +(
            items.amount.find(
              val => val.title.toLowerCase() === month.toLowerCase()
            ) || {}
          ).value;
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
      if (Number(amountTotal) === 0) {
        return '-';
      } else {
        return amountTotal;
      }
    },
    totalAmountFor(key) {
      return this.dataItems
        .reduce((total, val) => {
          const value = +(val[key] || 0);
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
    },
    pushColumn() {
      // push object group ke spendingcolumn
      this.spendingColumn.splice(
        4,
        0,
        ...this.dataItems[0].group.map(item => {
          return {
            ...item,
            title: item.title.name,
            value: item.value
          };
        })
      );
      if (this.isLoggedInAsSales) {
        // cari index budget owner buat push account & channel soalnya ditampilin setelah kolom BO
        let indexBO = this.spendingColumn.findIndex(
          val => val.title == 'Budget Owner'
        );
        let indexEnd = this.spendingColumn.findIndex(val => val.title == 'End');
        let fieldChannel = {
          title: 'Channel',
          value: 'channel',
          field: 'channel',
          isCode: true
        };
        let fieldAccount = {
          title: 'Account',
          value: 'account',
          field: 'account',
          isCode: true
        };
        let fieldInvestment = {
          title: 'Investment Type',
          value: 'investment_type',
          field: 'investment_type',
          isCode: false
        };
        // push object Channel ke spendingcolumn
        this.spendingColumn.splice(indexBO + 1, 0, fieldChannel);
        // push object Account ke spendingcolumn
        this.spendingColumn.splice(indexBO + 2, 0, fieldAccount);
        this.spendingColumn.splice(indexEnd + 3, 0, fieldInvestment);
      }
      // cari inder activity description buat push amount soalnya amount ditampilin setelah kolom activity description
      let indexActivity = this.spendingColumn.findIndex(
        val => val.title == 'Activity Description'
      );
      // push object amount ke spendingcolumn
      this.spendingColumn.splice(
        indexActivity + 1,
        0,
        ...this.dataItems[0].amount
      );
      // if (this.page === 'approval') {
      this.spendingColumn.push({
        title: 'Details',
        value: 'action',
        field: '',
        isCode: true
      });
      // }

      this.columnActive = this.spendingColumn.map(column => {
        return column.title;
      });
    },
    firstColumnActive() {
      let column = localStorage.getItem('columnActive');
      let arrColumn = null;
      if (column) {
        arrColumn = column.split(',');
      } else {
        arrColumn = this.spendingColumn.map(element => {
          return element.title;
        });
      }
      if (this.spendingColumn !== arrColumn) {
        this.columnActive = arrColumn;
      } else {
        this.columnActive = this.spendingColumn.map(element => {
          return element.title;
        });
      }
    },
    handleRefresh() {
      let column = this.spendingColumn.map(element => {
        return element.title;
      });
      localStorage.setItem('columnActive', column);
    },
    selectAllColumn() {
      if (this.selectAll) {
        this.selectAll = false;
        this.columnActive = [];
      } else {
        this.selectAll = true;
        this.columnActive = this.spendingColumn.map(column => {
          return column.title;
        });
      }
    },
    checkColumnActive(item) {
      if (item) {
        let month;
        if (item.month === 'total') {
          month = 'Full Year IO';
        } else {
          month = item.month.charAt(0).toUpperCase() + item.month.slice(1);
        }
        return this.columnActive.includes(month);
      } else {
        return true;
      }
    },
    bgStatusActive(val, valActive, isSupportingDocs) {
      if (valActive) {
        return 'active-io';
      } else {
        if (val) {
          return 'softpink';
        } else {
          if (isSupportingDocs) {
            return 'isSupportingDoc';
          } else {
            return 'white';
          }
        }
      }
    },
    bgReject(val, valActive, isSupportingDocs) {
      if (valActive) {
        return 'active-io';
      } else {
        if (val) {
          return 'bgPink';
        } else {
          if (isSupportingDocs) {
            return 'isSupportingDoc';
          } else {
            return '';
          }
        }
      }
    },
    goTo(item) {
      localStorage.setItem('prevYear', this.year);
      localStorage.setItem('idItem', JSON.stringify(item.id));
      //open new tab to detail spending
    },
    getAscSort(obj) {
      this.dataItems.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.dataItems);
    },
    searchCln(obj) {
      let nameField = obj.fieldName;
      let arr = this.dataItemsFull;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        this.dataItems = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(a[nameField].toString());
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          this.dataItems = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          this.dataItems = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          this.dataItems = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        }
      }
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        if (name === 'start') {
          name = 'dateStart';
        } else if (name === 'end') {
          name = 'dateEnd';
        }
        let dataFiltered = this.dataItemsFull.reduce((result, arr) => {
          result[arr[name]] = [...(result[arr[name]] || []), arr];
          return result;
        }, {});
        return Object.keys(dataFiltered);
      } else {
        let nameField = name.split('.');
        let dataFiltered = [];
        switch (nameField.length) {
          case 2:
            dataFiltered = this.dataItemsFull.reduce((result, arr) => {
              if (!arr[nameField[0]]) return;
              result[arr[nameField[0]][nameField[1]]] = [
                ...(result[arr[nameField[0]][nameField[1]]] || []),
                arr
              ];
              return result;
            }, {});
            break;
          case 3:
            dataFiltered = this.dataItemsFull.reduce((result, arr) => {
              if (!arr[nameField[0]]) return;
              result[arr[nameField[0]][nameField[1]][nameField[2]]] = [
                ...(result[arr[nameField[0]][nameField[1]][nameField[2]]] ||
                  []),
                arr
              ];
              return result;
            }, {});
            break;
          case 4:
            dataFiltered = this.dataItemsFull.reduce((result, arr) => {
              if (!arr[nameField[0]]) return;
              result[
                arr[nameField[0]][nameField[1]][nameField[2]][nameField[3]]
              ] = [
                ...(result[
                  arr[nameField[0]][nameField[1]][nameField[2]][nameField[3]]
                ] || []),
                arr
              ];
              return result;
            }, {});
            break;
        }
        return Object.keys(dataFiltered);
      }
    }
  }
};
</script>
<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.drawer-menu--scroll {
  max-height: 250px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
.drawer-menu--scroll-filter {
  max-height: 283px;
  overflow: auto;
}
.drawer-menu--scroll-filterDept {
  max-height: 136px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}
.v-menu__content {
  background: #fff !important;
}
.menuColumn {
  max-height: 250px;
}
tr:hover {
  background-color: #f5f5f5 !important;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
</style>
